export default "__VITE_PUBLIC_ASSET__599f0821__"